import Vue from "vue";


export default {
  SET_SYSTEM_TRANSITION_DIVISION_INFO(state, params) {
    state.divisionInfo = params;
  },
  SET_SYSTEM_TRANSITION_DATA(state, params) {
    state.gridData = params;
    state.oriGridData = _.cloneDeep(params.rows);
  },
  SET_IAM_USER_DATA(state, params) {
    state.iamUserData = params;
  },
  SET_ADMIN_YN(state, params) {
    state.adminYn = params;
    state.searchParam.adminYn = params;
  },
  SET_CUT_OVER_STATUS(state, params) {
    state.statusList = params;
  },
  UPDATE_SEARCH_PARAMS(state, params) {
    state.searchParam.accountDeletedYn = params.accountDeletedYn;
    state.searchParam.adminYn = params.adminYn;
    state.searchParam.cutOverCompleteYn = params.cutOverCompleteYn;
    state.searchParam.divisionCd = params.divisionCd;
    state.searchParam.domestic = params.domestic;
    state.searchParam.gbmgroup = params.gbmgroup;
    state.searchParam.projectCreateYn = params.projectCreateYn;
    state.searchParam.searchType = params.searchType;
    state.searchParam.tab = params.tab;
  },
  SET_UPDATE_ROUTE_INIT(state, params) {
    state.searchParam.routeInit = params;
  },
};



// WEBPACK FOOTER //
// ./src/vuex/systemTransition/systemTransitionMutation.js